import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import * as moment from 'moment';
import { TaskServiceDetailService } from '../task-service-detail.service';
import { getDomainOptions } from '@app/_constants/task-code-registry';

@Component({
  selector: 'app-service-detail-rollup',
  templateUrl: './service-detail-rollup.component.html',
  styleUrls: ['./service-detail-rollup.component.scss'],
  providers: [MessageService],
  standalone: false
})
export class ServiceDetailRollupComponent implements OnInit {

  loading = false;

  // Filters
  dateRange: Date[] = [];
  regionFilter: number | null = null;
  selectedProperties: any[] = [];
  serviceTagFilter: string | null = null;
  qualityGradeRange: number[] = [1, 10];

  regionOptions = getDomainOptions('REGION');
  propertyOptions: any[] = [];
  serviceTagOptions: string[] = [
    'Departure Clean', 'Mid-Stay Clean', 'Inspector', 'Shower Glass',
    'BBQ', 'Pool / Spa', 'Pest Control', 'Landscape', 'HVAC', 'Plumbing'
  ];

  // Scorecard data
  propertyScorecard: any[] = [];
  vendorScorecard: any[] = [];
  recentCompletions: any[] = [];

  constructor(
    private taskServiceDetailService: TaskServiceDetailService,
    public router: Router,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const thirtyDaysAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 30);
    this.dateRange = [thirtyDaysAgo, today];
    this.loadData();
  }

  loadData(): void {
    if (!this.dateRange || this.dateRange.length < 2 || !this.dateRange[1]) {
      return;
    }
    this.loading = true;

    const startDate = moment(this.dateRange[0]).format('YYYY-MM-DD');
    const endDate = moment(this.dateRange[1]).format('YYYY-MM-DD');

    this.taskServiceDetailService.getRollup(
      startDate,
      endDate,
      this.regionFilter,
      this.selectedProperties.map(p => p.value),
      this.serviceTagFilter
    ).subscribe({
      next: (res) => {
        if (res && res.data && res.data['rollup']) {
          const rollup = res.data['rollup'];
          this.propertyScorecard = rollup.propertyScorecard || [];
          this.vendorScorecard = rollup.vendorScorecard || [];
          this.recentCompletions = rollup.recentCompletions || [];
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Service detail rollup failed', err);
        this.loading = false;
      }
    });
  }

  applyFilters(): void {
    this.loadData();
  }

  getQualityClass(grade: number): string {
    if (grade == null) { return ''; }
    if (grade < 6) { return 'quality-red'; }
    if (grade < 8) { return 'quality-amber'; }
    return 'quality-green';
  }

  onViewTask(taskId: number): void {
    this.router.navigate(['/task-list'], { queryParams: { taskId } });
  }

  onViewVendor(vendorId: number): void {
    this.router.navigate(['/vendors', vendorId]);
  }
}
